var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"not-authorized"},[_c('h1',{staticClass:"not-authorized__title"},[_vm._v("Hey now!")]),_c('p',[_vm._v("\n    you do not belong here.\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }